/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import * as UserActions from 'ContentData/actions/Users';
import * as userSelectors from 'ContentData/selectors/users';
import { Select } from 'foundations-components/components/Select';
import { getSelectedValues } from 'ContentComponents/cmv2/utils';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { isEqual } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.email.${key}`;
const mapStateToProps = state => ({
  options: userSelectors.getOptions(state),
  users: userSelectors.getUsers(state),
  isLoading: userSelectors.getIsLoading(state)
});
const mapDispatchToProps = {
  fetchUsers: UserActions.fetchUsers
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class EmailField extends Component {
  constructor(props) {
    super(props);
    this.getValidSelectedEmails = () => {
      const {
        users
      } = this.props;
      const {
        selectedValues
      } = this.state;
      return getSelectedValues(selectedValues).filter(selectedValue => {
        return users[selectedValue] && users[selectedValue].canNotify;
      });
    };
    this.onChange = this.onChange.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.state = {
      input: '',
      selectedValues: getSelectedValues(this.props.value)
    };
  }
  componentDidMount() {
    const {
      options
    } = this.props;
    if (!options.length) {
      // on initial load get user data to check canNotify = false with
      this.props.fetchUsers();
    }
  }
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.options, this.props.options)) {
      this.setState({
        selectedValues: this.getValidSelectedEmails()
      });
    }
  }
  onChange(emailValues) {
    const {
      onFieldChange
    } = this.props;
    this.setState({
      selectedValues: emailValues
    });
    onFieldChange(emailValues);
  }
  onOpenChange(isOpen) {
    /**
     * This is a gross workaround for now. We can;t use both loadOptions and
     * multi = true in UISElect, so we have to mimic it for now until FaaST can
     * fix that issue.
     */
    if (isOpen) this.props.fetchUsers();
  }
  render() {
    const {
      readOnly = false,
      required,
      options,
      placeholder,
      useOnDark
    } = this.props;
    if (!options.length) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "extra-small",
        layout: "centered",
        grow: true
      });
    }
    return /*#__PURE__*/_jsx(Select, {
      referenceVariant: useOnDark ? 'on-dark' : 'default',
      clearable: !required,
      error: false,
      multi: true,
      onSelectedOptionChange: ({
        selectedValues
      }) => this.onChange(selectedValues),
      onOpenChange: isOpen => {
        this.onOpenChange(isOpen);
      },
      options: options,
      selectedItemsPlaceholder: placeholder || I18n.text(i18nKey('placeholder')),
      disabled: readOnly,
      selectedValues: this.state.selectedValues,
      searchable: true,
      supportText: I18n.text(i18nKey('invalidEmail'))
    });
  }
}
export default connector(EmailField);